// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navigation-module--navigation--_yI7y","navigationList":"navigation-module--navigationList--2Bu9Y"};